import React from 'react';
import Rodal from '../../../../components/Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import './EngagementDocumentPdfPreviewModal.scss';
import { useBodyScrollLock } from '../../../../hooks/useBodyScrollLock';

interface EngagementDocumentPdfPreviewProps {
    isVisible: boolean;
    pdfUrl: string;
    onClose: () => void;
}

const EngagementDocumentPdfPreview = (
    props: EngagementDocumentPdfPreviewProps
) => {
    useBodyScrollLock();
    return (
        <Rodal
            className="engagement-document-pdf-preview"
            visible={props.isVisible}
            onClose={props.onClose}>
            <ModalHeader>Readonly Document Preview</ModalHeader>
            <ModalBody>
                <object
                    data={`${props.pdfUrl}#toolbar=0`}
                    type="application/pdf"
                    width="100%"
                    height="100%">
                    <p>
                        It appears you don't have a PDF plugin for this browser.
                        You can{' '}
                        <a href={props.pdfUrl}>
                            click here to download the PDF file.
                        </a>
                    </p>
                </object>
            </ModalBody>
        </Rodal>
    );
};

export default EngagementDocumentPdfPreview;
